module.exports = __webpack_public_path__ + "static/img/007.7cef3109.svg";